// extracted by mini-css-extract-plugin
module.exports = {"review-wrap":"style_review-wrap__3UQ0k","content":"style_content__1Ncak","pendant":"style_pendant__3ce2y"};